import styled from 'styled-components';
import { useEnvelope } from '../../hooks/useEnvelope';
import { getFile, getFileForAdhoc } from '../../services/file';
import { useMutation } from 'react-query';
import { useContext } from 'react';
import { FileContext } from '../../context/FileContext';
import Tooltip from 'monday-ui-react-core/dist/Tooltip';

const OuterContainer = styled.div`
  height: ${({ scalingFactor }) => 85 * scalingFactor + 'px'};
  width: ${({ width }) => (width ? width + 'px' : '100%')};
  margin-left: 16px;
  margin-right: 16px;
  background-color: white;
  font-size: ${({ scalingFactor }) => 14 * scalingFactor + 'px'};

  div {
    display: flex;
    align-items: center;
    height: 100%;
    padding: ${({ scalingFactor }) => 2 * scalingFactor + 'rem'};
    color: #323338;
    justify-content: space-between;

    div {
      height: 100%;
      gap: ${({ scalingFactor }) => 5 * scalingFactor + 'px'};
      padding: 0px;
    }
  }
`;

const CustomButton = styled.button`
  z-index: 1000;
  text-align: center;
  padding: ${({ scalingFactor }) => {
    return `${5 * scalingFactor}px ${8 * scalingFactor}px`;
  }};
  border-radius: 4px;
  border: 1px solid #1f76c2;
  background-color: white;
  color: #1f76c2;
  font-size: ${({ scalingFactor }) => 14 * scalingFactor + 'px'};
  cursor: pointer !important;

  :hover {
    scale: 1.2 !important;
  }
`;

const SwitchPageLayer = ({ scalingFactor, file, width }) => {
  const { envelopeId } = useContext(FileContext);

  const {
    isAdhoc,
    envelopeData,
    setActiveFileId,
    setActiveFileData,
    setFileTopAndBottom,
    scrollToTop,
  } = useEnvelope();

  const { mutate: getActiveFileById } = useMutation(getFile);
  const { mutate: getActiveFileByIdForAdhoc } = useMutation(getFileForAdhoc);

  const handleClick = (value) => {
    isAdhoc
      ? getActiveFileByIdForAdhoc(
          { envelopeId, assetId: value },
          {
            onSuccess: (res) => {
              const fileData = {
                _id: res?.mondayFileDetails?.[0]?.id,
                file: res?.base64File,
                file_name: res?.mondayFileDetails?.[0]?.name,
                board_id: res?.envelopeDetails?.board_id,
                account_id: res?.envelopeDetails?.account_id,
                fields: res?.fileDetails?.fields || [],
                pages_added_by_users: [],
              };
              setActiveFileId(value);
              setActiveFileData(fileData, true);
              setFileTopAndBottom(envelopeData.attachedFiles, value);
              scrollToTop();
            },
          },
        )
      : getActiveFileById(value, {
          onSuccess: (res) => {
            setActiveFileId(value);
            setActiveFileData(res.data);
            setFileTopAndBottom(envelopeData.attachedFiles, value);
            scrollToTop();
          },
        });
  };

  const truncateString = (text, limit) => {
    return text?.length > limit ? (
      <div>
        <Tooltip content={text} zIndex={4}>
          <span className="cursor-pointer">
            {text.substring(0, limit) + '...'}
          </span>
        </Tooltip>
      </div>
    ) : (
      <span>{text}</span>
    );
  };

  return (
    <OuterContainer scalingFactor={scalingFactor} width={width}>
      <div>
        <div>
          Continue to edit
          <strong>
            {truncateString(file?.file_name || file?.fileName, 30)}
          </strong>
        </div>
        <CustomButton
          scalingFactor={scalingFactor}
          onClick={() => handleClick(file?._id || file?.assetId)}
        >
          Prepare
        </CustomButton>
      </div>
    </OuterContainer>
  );
};

export default SwitchPageLayer;
